// SPEC-LOGIN-BOUNCE-AFTER-SUCCESS-01 (D-838) AC2: 「最後に操作した時刻」の置き場所を 1 つにする。
//
// ★なぜ独立したファイルなのか
//   この時刻は 3 者が触る: 見張り(useIdleLogout)・ログアウト(auth/session.js)・ログイン(pages/Login.jsx)。
//   useIdleLogout は auth/session.js の logout() を輸入しているので、auth/session.js から
//   useIdleLogout を輸入し返すと **循環** になる(.dependency-cruiser.cjs の no-circular が落とす)。
//   どちらにも依存しない葉のファイルに置けば、3 者とも同じ 1 本を見る。
//   ★キーの文字列を 2 か所に書き写すと、片方だけ変わってずれる(D-616 と同じ轍)。
//
// ★中身は D-360 (SPEC-IDLE-LOCK-RELOAD-DURABILITY-01) が useIdleLogout.js に書いたものを
//   1 文字も変えずに移しただけ。判定・間引き・private mode の無害化はすべて呼び出し側のまま。

/** 元 S2 仕様の先例キー(commit 5738574)に合わせる。★ここだけが定義。 */
export const SESSION_ACTIVITY_KEY = 'session_last_activity'

/** 最後の活動時刻を読む。壊れた値・無い値は null(= 起動時ログアウトしない)。 */
export function readSessionActivity() {
  try {
    const raw = localStorage.getItem(SESSION_ACTIVITY_KEY)
    if (raw == null) return null
    const n = Number(raw)
    return Number.isFinite(n) && n > 0 ? n : null
  } catch { return null }                            // private mode / 例外環境: 無害化
}

/** 最後の活動時刻を書く。★private mode では黙って諦める(機能向上で既存を壊さない)。 */
export function writeSessionActivity(ts) {
  try { localStorage.setItem(SESSION_ACTIVITY_KEY, String(ts)) } catch { /* private mode: 無害化 */ }
}

/**
 * 最後の活動時刻を消す。
 * ★D-838: セッションが終わったら必ず消す。消し忘れた古い時刻が次のログインに持ち越されると、
 *   ログインした直後に「30 分以上放置されている」と誤判定されて即ログアウトされる
 *   (= ログイン画面へ押し戻される。2026-09-22 の auth_trace で 3/3 この形だった)。
 */
export function clearSessionActivity() {
  try { localStorage.removeItem(SESSION_ACTIVITY_KEY) } catch { /* noop */ }
}
